// extracted by mini-css-extract-plugin
export default {"card":"mjE7U","title":"lylNH","imageWrapper":"y3qKy","image":"GEvMd"};